import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.image_analysis');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-image_analysis',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.image_analysis/view.scss */
/* src/app/page.image_analysis/view.scss: no such file or directory */`],
})
export class PageImage_analysisComponent implements OnInit {
    public images: any[] = [];
    public options: any = this.defaultOptions();
    public loading: boolean = false;
    public error: string = '';
    public result: any = null;
    private nextImageId: number = 1;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public defaultOptions() {
        return {
            threshold: 20,
            grid: 4,
            legacyShadowMode: true,
            removeOverlap: true,
            shadowCropRadius: 25,
            maxPreviewCrops: 80
        };
    }

    public get hasImages() {
        return this.images.length > 0;
    }

    public get summaryRows() {
        return this.result && this.result.summaryRows ? this.result.summaryRows : [];
    }

    public get previewCrops() {
        return this.result && this.result.previewCrops ? this.result.previewCrops : [];
    }

    public get aggregateRows() {
        return this.result && this.result.aggregateRows ? this.result.aggregateRows : [];
    }

    public async onFileChange(event: any) {
        const input = event && event.target ? event.target : null;
        const files: File[] = input && input.files ? (Array.from(input.files as FileList) as File[]) : [];
        if (!files.length) return;

        const items: any[] = [];
        for (const file of files) {
            if (!/^image\/(png|jpeg|jpg|webp)$/i.test(file.type || '')) {
                this.error = 'PNG, JPG, WEBP 이미지만 업로드할 수 있습니다.';
                await this.service.render();
                if (input) input.value = '';
                return;
            }
            if (file.size > 30 * 1024 * 1024) {
                this.error = '이미지 파일은 각각 30MB 이하만 사용할 수 있습니다.';
                await this.service.render();
                if (input) input.value = '';
                return;
            }
            items.push({
                id: `image-${this.nextImageId++}`,
                name: file.name || `image-${this.nextImageId}`,
                size: file.size,
                dataUrl: await this.readFileAsDataUrl(file)
            });
        }

        this.images = [...this.images, ...items];
        this.result = null;
        this.error = '';
        if (input) input.value = '';
        await this.service.render();
    }

    public async analyze() {
        if (!this.images.length) {
            alert('먼저 이미지를 업로드해 주세요.');
            return;
        }

        this.loading = true;
        this.error = '';
        this.result = null;
        await this.service.render();

        const payload = {
            images: this.images.map((item: any) => ({
                filename: item.name,
                dataUrl: item.dataUrl
            })),
            threshold: this.options.threshold,
            grid: this.options.grid,
            legacyShadowMode: this.options.legacyShadowMode,
            removeOverlap: this.options.removeOverlap,
            shadowCropRadius: this.options.shadowCropRadius,
            cropRadius: 25,
            maxPreviewCrops: this.options.maxPreviewCrops
        };

        try {
            const response = await wiz.call('analyze_images', { payload: JSON.stringify(payload) });
            const data = response.data || {};
            if (response.code !== 200) {
                throw new Error(data.message || '이미지 분석에 실패했습니다.');
            }
            this.result = data;
        } catch (error: any) {
            this.error = error && error.message ? error.message : '이미지 분석 중 오류가 발생했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public deleteImage(index: number) {
        if (index < 0 || index >= this.images.length) return;
        this.images = this.images.filter((_: any, i: number) => i !== index);
        this.result = null;
        this.error = '';
    }

    public async reset() {
        this.images = [];
        this.options = this.defaultOptions();
        this.loading = false;
        this.error = '';
        this.result = null;
        this.nextImageId = 1;
        await this.service.render();
    }

    public downloadExcel() {
        if (!this.result || !this.result.excelDataUrl) return;
        this.downloadDataUrl(this.result.excelDataUrl, this.result.excelFilename || 'shadow_analysis.xlsx');
    }

    public downloadSelectedExcel() {
        if (!this.result || !this.result.selectedExcelDataUrl) return;
        this.downloadDataUrl(this.result.selectedExcelDataUrl, this.result.selectedExcelFilename || 'shadow_selected_metrics.xlsx');
    }

    public downloadZip() {
        if (!this.result || !this.result.zipDataUrl) return;
        this.downloadDataUrl(this.result.zipDataUrl, this.result.zipFilename || 'shadow_crops.zip');
    }

    private readFileAsDataUrl(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(String(reader.result || ''));
            reader.onerror = () => reject(reader.error || new Error('이미지를 읽지 못했습니다.'));
            reader.readAsDataURL(file);
        });
    }

    private downloadDataUrl(dataUrl: string, filename: string) {
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
}

export default PageImage_analysisComponent;